/**
 * Australian dollar.
 */
export var AUD = {
  code: 'AUD',
  base: 10,
  exponent: 2
};